const initialState = () => ({
  entitiesInfo: {
    pagination: {},
    items: [],
  },
});

const state = initialState();

export default state;
